export default "__VITE_ASSET__ah2AMV0Y__"